import React, { useState } from 'react';
import { parse, stringify } from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '../../projects/useStewardshipFilter';
import REQUIRED_FIELDS_PUBLIC from '../../projects/REQUIRED_FIELDS_PUBLIC';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10 } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('project.find', {
    where: {
      eager: {
        // $aggregations: [
        //   'Pending',
        //   'Connect',
        //   'Decline'
        // ].map(function(response) {
        //   return {
        //     type: 'count',
        //     alias: `numberOfQuestions${response}`,
        //     relation: 'questions',
        //     $where: {
        //       response: response
        //     }
        //   };
        // }),
        $aggregations: [
          'Connect',
          'Pending'
        ].map(function(response) {
          return {
            type: 'count',
            alias: `numberOfQuestions${response}`,
            relation: 'questions',
            $where: {
              response: response
            }
          };
        }),
        $where: {
          $and: REQUIRED_FIELDS_PUBLIC.$and,
          // endDate: {
          //   $or: {
          //     $equals: null,
          //     $gte: timestamp
          //   }
          // },
          $or: stewardshipFilter
        },
        $having: {
          // numberOfQuestionsPending: 0,
          numberOfQuestionsConnect: 0,
          // numberOfQuestionsDecline: 0,
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function(model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}
